import { NgModule } from '@angular/core';
import { NumericDirective } from './numeric-directive.component';
import { ValidDaysDirective } from './valid-days.directive';
import { ValidYearsDirective } from './valid-years.directive';


@NgModule({
  imports: [

 ],
  exports: [
    NumericDirective,
    ValidDaysDirective,
    ValidYearsDirective
  ],
  declarations: [
    NumericDirective,
    ValidDaysDirective,
    ValidYearsDirective,
  ],
  entryComponents: [
  ]
})
export class DirectivesModule { }
